import { render } from "./Presentar-Tv.vue?vue&type=template&id=0e409d9f&scoped=true"
import script from "./Presentar-Tv.vue?vue&type=script&lang=js"
export * from "./Presentar-Tv.vue?vue&type=script&lang=js"

import "./Presentar-Tv.vue?vue&type=style&index=0&id=0e409d9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e409d9f"]])

export default __exports__